<template>
  <div class="login-container">
    <LogoIcon />
    <span class="title">Verify your email</span>
    <div class="subtitle">
      Enter the code we sent to {{ email }}
    </div>
    <div class="login-content">
      <div class="code">
        <CodeVerificationInputs @code="codeInput" />
      </div>
      <button
        @click="verifyEmailToken"
        class="button-default big continue"
        :disabled="isVerifying || !email_token"
      >
        {{ isVerifying ? "Verifying..." : "Verify and Continue" }}
      </button>
      <div class="resend">
        <span>Didn’t receive the code?</span>
        <span
          @click="resendEmailToken"
          class="resend-button"
          :class="{ 'resend-disabled': requestAgainDisabled }"
        >
          <span v-if="isResending">Resending...</span>
          <span v-else>Request Again{{ countdown ? ` in ${countdownText}` : '' }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import LogoIcon from "@/components/LogoTile";
  import CodeVerificationInputs from "@/components/Custom/CodeVerificationInputs";
  import { mapState } from "vuex";
  import { M_VERIFY_EMAIL, M_CHECK_SIGNUP_STEP } from "@/graphql";
  
  export default {
    name: "SignupWizardStepVerifyEmail",
    components: {
      LogoIcon,
      CodeVerificationInputs
    },
    data() {
      return {
        isVerifying: false,
        isResending: false,
        email_token: null,
        countdown: 0
      };
    },
    created() {
      this.startCountdown();
    },
    computed: {
      ...mapState("signup", ["email"]),
      countdownText() {
        const minutes = Math.floor(this.countdown / 60);
        const seconds = this.countdown % 60;
        const secondsText = seconds < 10 ? `0${seconds}` : seconds;
        return `${minutes}:${secondsText}`;
      },
      requestAgainDisabled() {
        return this.isResending || this.countdown > 0;
      }
    },
    methods: {
      startCountdown() {
        this.countdown = 120;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
          }
        }, 1000);
      },
      async verifyEmailToken() {
        this.isVerifying = true;
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_VERIFY_EMAIL,
          variables: {
            email: this.email,
            email_token: this.email_token
          }
        });

        this.isVerifying = false;
        const { success } = result.data.verify_email;

        if (!success) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Invalid code, Please enter a valid code."
          });
          return;
        }

        this.$store.commit("signup/setEmailPending", false);
        this.$emit("nextStep");
      },
      async codeInput(val) {
        const code = val.join("");
        if (code.length === 6) {
          this.email_token = code;
        } else {
          this.email_token = null;
        }
      },
      async resendEmailToken() {
        if (this.requestAgainDisabled) return;

        this.isResending = true;
        await this.$apollo.mutate({
          client: "localClient",
          mutation: M_CHECK_SIGNUP_STEP,
          variables: {
            email: this.email
          }
        });

        this.startCountdown();
        this.isResending = false;
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .login-container {
    width: 100vw;
    height: 100%;
    /* BG/type2 */
    background: $bg-type-2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo-icon {
      width: 54px;
    }
    .title {
      display: block;
      margin-top: 30px;
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 30px;
      line-height: 42px;
      /* White */
      color: #ffffff;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .login-content {
      width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 12px;
      .code {
        margin: 40px 0;
      }
      button.continue {
        width: 100%;
      }
      .resend {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .resend-button {
          margin-top: 8px;
          font-weight: 600;
          color: #9c27b0;
          cursor: pointer;
          &:hover {
            color: #ffffff;
          }
        }
        .resend-disabled {
          cursor: not-allowed;
          &:hover {
            color: #9c27b0 !important;
          }
        }
      }
    }
  }
  @media (max-width: 600px) {
    .login-container {
      padding: 24px;
      .title {
        text-align: center;
      }
      .login-content {
        width: 100%;
        padding: 0;
        .inputs {
          grid-template-columns: repeat(1, 100%);
          width: 100%;
        }
      }
    }
  }
  
  
  </style>
  